module.exports = __webpack_public_path__ + "static/img/step01.b42ca32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step01.png
// module id = ERXy
// module chunks = 1